<template>
    <div class="cc-login" v-if="isUserLoginFormShown">
        <div class="cc-login__main">
            <div class="cc-grid">
                <div class="cc-grid__row">
                    <div class="cc-grid__col-mobile--12 cc-grid__col-desktop--6">
                        <div class="cc-form-element cc-form-element--with-floating-label cc-form-element--with-top-margin">
                            <input id="login.email" type="email" name="login.email" class="cc-input cc-input--text cc-input--full-width" :placeholder="`${translations['Email']}*`">
                            <label for="login.email" class="cc-label cc-label--text">{{ translations['Email'] }}*</label>
                        </div>
                        <div class="cc-alert cc-alert--error" v-if="user.loginErrors.email">{{ user.loginErrors.email }}</div>
                    </div>
                    <div class="cc-grid__col-mobile--12 cc-grid__col-desktop--6">
                        <div class="cc-form-element cc-form-element--with-floating-label cc-form-element--with-top-margin">
                            <input id="login.password" type="password" name="login.password" class="cc-input cc-input--text cc-input--full-width" :placeholder="`${translations['Password']}*`">
                            <label for="login.password" class="cc-label cc-label--text">{{ translations['Password'] }}*</label>
                        </div>
                        <div class="cc-alert cc-alert--error" v-if="user.loginErrors.password">{{ user.loginErrors.password }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="cc-login__forgot-password">
            <a :href="config.forgotten_password.link" class="cc-login__forgot-password-link cc-link">{{ config.forgotten_password.name }}</a>
        </div>
        <div class="cc-login__controls">
            <a class="cc-button cc-button--login" @click="login">{{ translations['Sign in'] }}</a>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        computed: {
            ...mapState({
                translations: state => state.translations,
                user: state => state.user,
                config: state => state.config,
                selectedCountry: state => state.user.deliveryAddress.country,
                selectedCarrier: state => state.selectedCarrier,
                currentCarrier: state => state.currentCarrier,
            }),
            pickupInStore: function () {
                return this.currentCarrier && this.currentCarrier.pickupInStore;
            },
        },
        methods: {
            login: function () {
                this.showLoading();
                const emailInput = document.getElementById('login.email');
                const passwordInput = document.getElementById('login.password');
                const selectedCountry = this.selectedCountry;

                let that = this;

                this.$store.dispatch('USER_LOGIN', {email: emailInput.value, password: passwordInput.value})
                    .then(function () {
                        if (parseInt(that.user.deliveryAddress.country) !== parseInt(selectedCountry)) {
                            that.$store.dispatch('LOAD_CARRIERS_AND_PAYMENTS').then(function () {
                                Promise.all([
                                    that.$store.dispatch('SELECT_CARRIER', null),
                                    that.$store.dispatch('SELECT_PAYMENT', null),
                                ]).then(() => {
                                    that.$store.commit('SET_ERROR_LOGIN_COUNTRY_MISMATCH', true);
                                    that.hideLoading();
                                })
                            });
                        } else {
                            if (typeof $.uniform !== 'undefined') {
                                $.uniform.update();
                            }

                            that.hideLoading();
                        }
                    });
            },
            showLoading: function () {
                const body = document.getElementsByTagName('body')[0];
                const coverSpin = document.createElement('div');
                coverSpin.id = 'cart-cover-spin';
                body.appendChild(coverSpin);
            },
            hideLoading: function () {
                document.getElementById('cart-cover-spin').remove();
            },
        },
        name: 'Login',
        props: [
            'isUserLoginFormShown',
        ],
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/components/login";
</style>
